var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXoFidqhm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "59px",
    viewBox: "0 0 60 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 31.821 0 31.821 31.721 0 31.721"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "end-call"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.614000, 0.110000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prp0ska8kb-link",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prp0ska8kb",
    cx: 29.535,
    cy: 29.535,
    r: 29.535
  })), /*#__PURE__*/React.createElement("g", {
    id: "prp0ska8kb-link",
    fill: "#EE3D85"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prp0ska8kb",
    cx: 29.535,
    cy: 29.535,
    r: 29.535
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.533807, 31.174227) rotate(135.000000) translate(-30.533807, -31.174227) translate(14.533807, 15.174227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1qk83pclic"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.968,0.63 C4.808,-0.21 6.28,-0.21 7.121,0.63 L12.166,5.676 C13.007,6.412 13.007,7.673 12.166,8.409 L9.538,11.14 C11.115,14.083 12.481,15.975 14.478,17.867 C16.265,19.654 18.262,20.81 20.68,22.177 L23.308,19.549 C24.148,18.709 25.305,18.709 26.145,19.549 L31.191,24.594 C32.031,25.435 32.031,26.801 31.191,27.747 C30.455,28.483 29.614,29.219 28.878,30.06 C20.47,38.68 -6.964,11.35 1.655,2.943 L3.968,0.631",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXoFidqhm);
export default __webpack_public_path__ + "static/media/XOFidqhm.b1899bf56aff93fb88923f7d954f7ff9.svg";
export { ForwardRef as ReactComponent };